import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setMobileMenuOpen(false);
    }
  };
  // Detect which page we're on based on the URL path
  const isBookACallPage = window.location.pathname.includes('heylloyd-book-a-call');
  const isWebinarReplyPage = window.location.pathname.includes('webinar-reply');
  // Navigation items based on page type
  const navItems = isBookACallPage ? [{
    label: 'Inicio',
    id: 'hero'
  }, {
    label: 'Beneficios',
    id: 'beneficios'
  }, {
    label: 'Proceso',
    id: 'proceso'
  }, {
    label: 'Resultados',
    id: 'resultados'
  }] : isWebinarReplyPage ? [{
    label: 'Inicio',
    id: 'hero'
  }, {
    label: 'Sistema',
    id: 'paso-1'
  }, {
    label: 'HeyLloyd',
    id: 'paso-2'
  }, {
    label: 'Custom Lloyds',
    id: 'paso-3'
  }, {
    label: 'Galería',
    id: 'gallery'
  }] : [{
    label: 'Inicio',
    id: 'hero'
  }, {
    label: 'Instalación',
    id: 'paso-1'
  }, {
    label: 'Cómo usar',
    id: 'paso-2'
  }, {
    label: 'Custom Lloyds',
    id: 'paso-3'
  }, {
    label: 'Galería',
    id: 'gallery'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50" data-id="element-241">
      {/* Breaking News Ticker */}
      <div className="bg-red-600 overflow-hidden whitespace-nowrap" data-id="element-242">
        <div className="inline-block animate-marquee py-1.5 text-white text-xs md:text-sm font-bold tracking-wide" data-id="element-243">
          <span className="mx-8" data-id="element-244">
            🔥 OFERTA ESPECIAL ÚNICA — Valor{' '}
            <span className="line-through" data-id="element-245">$776</span> → HOY GRATIS 🔥
          </span>
          <span className="mx-8" data-id="element-246">
            🔥 OFERTA ESPECIAL ÚNICA — Valor{' '}
            <span className="line-through" data-id="element-247">$776</span> → HOY GRATIS 🔥
          </span>
          <span className="mx-8" data-id="element-248">
            🔥 OFERTA ESPECIAL ÚNICA — Valor{' '}
            <span className="line-through" data-id="element-249">$776</span> → HOY GRATIS 🔥
          </span>
          <span className="mx-8" data-id="element-250">
            🔥 OFERTA ESPECIAL ÚNICA — Valor{' '}
            <span className="line-through" data-id="element-251">$776</span> → HOY GRATIS 🔥
          </span>
        </div>
      </div>
      <div className="bg-slate-900 border-b border-slate-800" data-id="element-252">
        <div className="container mx-auto px-4" data-id="element-253">
          <div className="flex items-center justify-between h-14 md:h-16" data-id="element-254">
            {/* Logo */}
            <button onClick={() => scrollToSection('hero')} className="flex items-center focus:outline-none focus:ring-2 focus:ring-cyan-500 rounded-lg" data-id="element-255">
              <img src="https://cdn.magicpatterns.com/uploads/adHaJFewYh1GEUG7kQr7LC/Heylloyd_white.svg" alt="HeyLloyd" className="h-7 md:h-8 w-auto" data-id="element-256" />
            </button>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center space-x-6 lg:space-x-8" data-id="element-257">
              {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-gray-200 hover:text-cyan-400 transition-colors text-sm font-medium" data-id="element-258">
                  {item.label}
                </button>)}
              <a href="https://app.heylloyd.io/web-checkout" target="_blank" rel="noopener noreferrer" data-id="element-259">
                <Button variant="cyan" size="sm" data-id="element-260">
                  Descargar
                </Button>
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-white p-2 hover:bg-slate-800 rounded-lg transition-colors" aria-label={mobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} data-id="element-261">
              {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-262" /> : <Menu className="w-6 h-6" data-id="element-263" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {mobileMenuOpen && <nav className="md:hidden py-3 border-t border-slate-800" data-id="element-264">
              <div className="flex flex-col space-y-1" data-id="element-265">
                {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-gray-100 hover:text-cyan-400 transition-colors text-left py-2.5 px-4 hover:bg-slate-800 rounded-lg text-base font-medium" data-id="element-266">
                    {item.label}
                  </button>)}
              </div>
            </nav>}
        </div>
      </div>
    </header>;
}